var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-cell-tick"},[(_vm.value)?_c('CommonIcon',{attrs:{"id":"check","color":"#3b93f7"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }